import EventsHero from './../components/EventsHero.jsx'; 
import EventCards from './../components/EventCards.jsx'; 
import ContactForm from './../components/ContactForm.jsx'; 
import foxTextSplitter from './../assets/images/Splitters/foxTextSplitter.webp'

const Events = () => {
  return (
    <div>
      <EventsHero />
      <EventCards />
      <div className='flex justify-center py-6'>
          <img src={foxTextSplitter} alt="fox divider" className='w-[800px]' />
      </div>
      <ContactForm/>
    </div>
  )
}

export default Events